module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ql-app"
    },
    on: {
      "mousemove": _vm.selectMouseCoordinates
    }
  }, [(_vm.loaded && !_vm.canEditActiveProject) ? _c('div', {
    staticClass: "ql-readonly-banner",
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "left": "0",
      "right": "0",
      "z-index": "2000",
      "background": "#37474f",
      "color": "#fff",
      "text-align": "center",
      "padding": "6px 12px",
      "font-size": "13px",
      "line-height": "1.3",
      "box-shadow": "0 -2px 6px rgba(0,0,0,0.25)"
    }
  }, [_vm._v("\n        You have "), _c('strong', [_vm._v("read-only")]), _vm._v(" access to this project.\n        "), _c('use-show-pass', {
    attrs: {
      "variant": "bar"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-dialog', {
    ref: "bannerDialog",
    staticClass: "alert-banner-dialog",
    attrs: {
      "md-click-outside-to-close": false,
      "md-esc-to-close": false
    }
  }, [(_vm.editedUser) ? _c('md-dialog-content', {
    staticClass: "alert-content"
  }, [_c('div', {
    staticClass: "alert-box"
  }, [_c('div', {
    staticClass: "alert-icon-box"
  }, [_c('md-icon', {
    staticClass: "alert-icon"
  }, [_vm._v("warning")])], 1), _vm._v(" "), _c('div', {
    staticClass: "alert-text-box"
  }, [_c('h3', {
    staticClass: "alert-title"
  }, [_vm._v("Hold, please!")]), _vm._v(" "), _c('p', {
    staticClass: "alert-message"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.editedUser || 'A collaborator'))]), _vm._v(" is currently adding, deleting, or replacing pdf pages in this project. Please wait until the action is completed or canceled.\n                        "), (_vm.user && _vm.project.ownerUID === _vm.user.uid) ? _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "8px"
    }
  }, [_vm._v("As the owner, you can take over by clicking the close button below.")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.project.ownerUID === _vm.user.uid) ? _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.closeAlert
    }
  }, [_vm._v("Close anyway")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "header-main"
  }, [(_vm.loaded) ? _c('project-header', {
    attrs: {
      "user": _vm.user,
      "currentPage": _vm.currentPage,
      "locked": _vm.isLocked,
      "showMode": _vm.showMode,
      "showMarginView": _vm.showMarginView,
      "bookmarkNavOpened": _vm.bookmarkNavOpened,
      "listView": _vm.listView,
      "selectedPageRenameIndices": _vm.selectedPageRenameIndices,
      "thumbnailPage": _vm.thumbnailPage || _vm.currentPage,
      "thumbnailStep": _vm.thumbnailPerRow
    },
    on: {
      "pageUp": _vm.pageUp,
      "pageDown": _vm.pageDown,
      "setPage": _vm.setCurrentPage,
      "setThumbnailPage": _vm.goToThumbnailPage,
      "toggleShowMode": _vm.toggleShowMode,
      "toggleMarginView": _vm.toggleMarginView,
      "toggleLocked": _vm.toggleLocked,
      "toggleBookmarkNav": _vm.toggleBookmarkNav,
      "toggleListView": _vm.toggleListView
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loaded && !_vm.listView) ? _c('project-sub-header', {
    attrs: {
      "user": _vm.user,
      "currentPage": _vm.currentPage,
      "locked": _vm.getLockedStatus(),
      "showMode": _vm.showMode,
      "bookmarkNavOpened": _vm.bookmarkNavOpened,
      "listView": _vm.listView,
      "selectedElement": _vm.selectedElement,
      "historyIndex": _vm.historyIndex,
      "history": _vm.history,
      "selectedPageRenameIndices": _vm.selectedPageRenameIndices,
      "pageHeight": _vm.pageHeight,
      "pageWidth": _vm.pageWidth,
      "pageFollow": _vm.pageFollowState
    },
    on: {
      "thumbnailSelectionClick": _vm.thumbnailSelectionClick,
      "setScale": _vm.setScale,
      "updateHistory": _vm.updateHistory,
      "setSelectedElement": _vm.setSelectedElement,
      "pasteCueNote": _vm.pasteCueNote,
      "pageUp": _vm.pageUp,
      "pageDown": _vm.pageDown,
      "setPage": _vm.setCurrentPage,
      "setFollowUid": _vm.setFollowUid,
      "toggleLocked": _vm.toggleLocked,
      "toggleBookmarkNav": _vm.toggleBookmarkNav,
      "toggleListView": _vm.toggleListView,
      "copyElement": _vm.copyElement
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.loaded) ? _c('core-nav-main', {
    attrs: {
      "currentPage": _vm.currentPage,
      "showMode": _vm.showMode,
      "locked": _vm.isLocked
    },
    on: {
      "toggleLocked": _vm.toggleLocked
    }
  }) : _vm._e(), _vm._v(" "), _c('project-worknote-cues-nav'), _vm._v(" "), (_vm.loaded && _vm.selectedThumbnailView === 'true') ? _c('md-layout', {
    staticClass: "page-viewer pdf-thumbnail",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('md-layout', [_c('project-thumbail-pages', {
    key: _vm.thumbnailKey,
    ref: "thumbnailPages",
    attrs: {
      "bookmarkNavOpened": _vm.bookmarkNavOpened,
      "currentPage": _vm.currentPage % 2 === 0 ? _vm.currentPage - 1 : _vm.currentPage > 1 ? _vm.currentPage : _vm.currentPage,
      "startPage": _vm.thumbnailPage || _vm.currentPage,
      "locked": _vm.getLockedStatus(),
      "showMode": _vm.showMode,
      "totalPages": _vm.totalPages,
      "selectedPageRenameIndices": _vm.selectedPageRenameIndices
    },
    on: {
      "toggleBookmarkNav": _vm.toggleBookmarkNav,
      "thumbnailSelectionClick": _vm.thumbnailSelectionClick,
      "thumbnailPageChanged": function($event) {
        _vm.thumbnailPage = $event
      },
      "perRowChanged": function($event) {
        _vm.thumbnailPerRow = $event
      },
      "gotoPage": _vm.gotoPage
    }
  }), _vm._v(" "), (_vm.listView) ? _c('project-list-view', {
    attrs: {
      "currentPage": _vm.currentPage % 2 === 0 ? _vm.currentPage - 1 : _vm.currentPage > 1 ? _vm.currentPage : _vm.currentPage
    },
    on: {
      "gotoPage": _vm.gotoPage,
      "switchViewToPage": _vm.switchViewToPage
    }
  }) : _vm._e()], 1)], 1) : (_vm.loaded) ? _c('md-layout', {
    staticClass: "page-viewer",
    class: {
      'split-view': _vm.inSplitView,
      'split-dragging': _vm.splitDragging
    },
    style: (_vm.inSplitView ? {
      '--pdf-frac': _vm.splitRatio
    } : {})
  }, [_c('project-bookmark-nav', {
    attrs: {
      "bookmarkNavOpened": _vm.bookmarkNavOpened,
      "activeBookmarkTab": _vm.activeBookmarkTab,
      "focusBookmarkPage": _vm.focusBookmarkPage,
      "currentPage": _vm.currentPage % 2 === 0 ? _vm.currentPage - 1 : _vm.currentPage > 1 ? _vm.currentPage : _vm.currentPage
    },
    on: {
      "toggleBookmarkNav": _vm.toggleBookmarkNav,
      "gotoPage": _vm.gotoPage,
      "setBookmarkTab": _vm.setBookmarkTab,
      "clearBookmarkFocus": _vm.clearBookmarkFocus
    }
  }), _vm._v(" "), (!_vm.reloading) ? _c('project-pages', {
    attrs: {
      "bookmarkNavOpened": _vm.bookmarkNavOpened,
      "currentPage": (_vm.selectedPageType === 'no' || (_vm.selectedPageType === 'even')) ? _vm.currentPage : _vm.currentPage % 2 === 0 ? _vm.currentPage - 1 : _vm.currentPage > 1 ? _vm.currentPage : _vm.currentPage,
      "locked": _vm.getLockedStatus(),
      "showMode": _vm.showMode,
      "showMarginView": _vm.showMarginView,
      "selectedElement": _vm.selectedElement,
      "totalPages": _vm.totalPages,
      "pageHeight": _vm.pageHeight
    },
    on: {
      "setSelectedElement": _vm.setSelectedElement,
      "copyElement": _vm.copyElement,
      "updatePageHistory": _vm.updatePageHistory,
      "toggleBookmarkNav": _vm.toggleBookmarkNav,
      "openBookmarkNav": _vm.openBookmarkNav,
      "setBookmarkTab": _vm.setBookmarkTab,
      "gotoPage": _vm.gotoPage,
      "getPageWidth": _vm.getPageWidth,
      "getPageHeight": _vm.getPageHeight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inSplitView) ? _c('div', {
    staticClass: "ql-split-divider",
    on: {
      "mousedown": _vm.onSplitDragStart,
      "touchstart": _vm.onSplitDragStart
    }
  }, [_c('span', {
    staticClass: "ql-split-grip"
  })]) : _vm._e(), _vm._v(" "), (_vm.listView || _vm.inSplitView) ? _c('project-list-view', {
    attrs: {
      "currentPage": _vm.inSplitView ? _vm.currentPage : (_vm.currentPage % 2 === 0 ? _vm.currentPage - 1 : _vm.currentPage > 1 ? _vm.currentPage : _vm.currentPage),
      "splitView": _vm.inSplitView,
      "pageSync": _vm.splitPageSync === 'true'
    },
    on: {
      "gotoPage": _vm.gotoPage,
      "switchViewToPage": _vm.switchViewToPage
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea0937c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/project.vue
// module id = 1230
// module chunks = 21